import React from 'react';
import ProjectRobotStatusDashboardPage from '../../Pages/ProjectRobotStatusDashboardPage';

const ProjectRobotStatusDashboardContainer = () => {
  return <ProjectRobotStatusDashboardPage/>;
};

export default ProjectRobotStatusDashboardContainer;
